import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChartSummary } from '@models/chart-summary.interface';

@Component({
  selector: 'app-chart-list',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './chart-list.component.html',
  styleUrl: './chart-list.component.scss'
})
export class ChartListComponent {
  @Input() charts: ChartSummary[] = [];
  @Input() selectedId: number | null = null;
  @Output() chartSelected = new EventEmitter<ChartSummary>();
  @Output() deleteClicked = new EventEmitter<number>();

  readonly displayedColumns = ['chartName', 'actions'];

  onRowClick(chart: ChartSummary): void {
    this.chartSelected.emit(chart);
  }

  onDeleteClick(chart: ChartSummary, event: Event): void {
    event.stopPropagation();
    this.deleteClicked.emit(chart.id);
  }
}